export const getNavLinkGroupStyles = (props) => {
    const { isNavCollapsed, theme, isCollapsibleSection } = props;
    return {
        nestedNavHeaderItem: {
            borderRadius: `0px ${theme.effects.roundedCorner4} 0px 0px`,
            '[dir="rtl"] &': {
                borderRadius: `${theme.effects.roundedCorner4} 0px  0px 0px `,
            },
        },
        nestedNavLinksWrapper: [isNavCollapsed && !isCollapsibleSection && {}],
        nestedNavLinks: [
            { backgroundColor: theme.semanticColors.navBackground },
            isNavCollapsed &&
                !isCollapsibleSection && {
                borderRadius: `0px 0px ${theme.effects.roundedCorner4} 0px`,
                '[dir="rtl"] &': {
                    borderRadius: `0px 0px 0px ${theme.effects.roundedCorner4}`,
                },
                'li:last-child :hover': {
                    borderRadius: `0px 0px ${theme.effects.roundedCorner4} 0px`,
                },
                '[dir="rtl"] & li:last-child :hover ': {
                    borderRadius: `0px 0px 0px ${theme.effects.roundedCorner4}`,
                },
            },
        ],
    };
};
//# sourceMappingURL=NavLinkGroup.styles.js.map